import React, { useState } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f4efe2', display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', height: '100vh' }}>
        <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />

        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <Header onMenuClick={toggleSidebar} />

          <main
            style={{
              flex: 1, overflowY: 'auto', position: 'relative',
              background: '#f4efe2',
            }}
          >
            {/* Subtle amber radial accent */}
            <div style={{
              position: 'fixed', top: 64, right: 0, width: 480, height: 480,
              background: 'radial-gradient(circle, rgba(217,119,6,0.05) 0%, transparent 70%)',
              pointerEvents: 'none', zIndex: 0,
            }} />
            <div style={{ position: 'relative', zIndex: 1, padding: '32px', maxWidth: 1400, margin: '0 auto' }}>
              {children}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};
